import React, { useState, useEffect, useContext } from 'react';
// design
import {
    Table,
    Space,
    Button,
    Upload,
    message,
    Popconfirm,
    Divider,
    Badge,
    Card,
    Row,
    Col,
    Typography,
    Select, Modal
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
// method
import { getMethod, postMethod, delMethod } from '../services/methods';
// dialog
import AddUserDialog from '../components/addUserDialog';
import TaskDialog from '../components/addTaskDialog';
// context
import { GlobalContext } from "../context/globalContext";
// utils
import { dateFormat } from '../utils/dateFormat';
import getStateList from "../utils/stateList";
import { Pagination } from 'antd';
import {taskStatusToText} from "../utils/helper";

const { Paragraph } = Typography;
const { Option } = Select;

export default function Users() {
    // context
    const itemsPerPage = 5;
    const { contextData, dispatch } = useContext(GlobalContext);
    const [stateList] = useState(getStateList().data)
    const [selectedState, setSelectedState] = useState(getStateList().data[0].il_adi);
    const [loading, setLoading] = useState(true);
    const [itemOffset, setItemOffset] = useState(0);

    const uploadAdminStateProps = {
        name: 'state',
        action: `${process.env.REACT_APP_API_PATH}/upload/user-state`,
        accept: '.xlsx',
        headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        onChange(info) {
            if (info.file.status === 'done') {
                setTimeout(() => {
                    message.success(`${info.file.name} dosya yükleme başarılı.`);
                    fetchData();
                }, 3000);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} dosya yüklenirken bir hata oluştu.`);
            }
        },
    };

    const [data, setData] = useState(null);
    const [dialog, setDialog] = useState(false);
    const [taskDialog, setTaskDialog] = useState(false);
    const [showEngagements, setShowEngagements] = useState(false);
    const [userEngagements, setUserEngagements] = useState([]);

    async function fetchData() {
        setLoading(true)
        const userData = await getMethod(`/user/${pagination.pageSize}/${pagination.pageSize * (pagination.current - 1)}?state=${selectedState}`);
        setData(userData.list)
        setPagination({
            ...pagination,
            total: userData?.count,
        });
        setLoading(false)
    }

    useEffect(() => {
        fetchData();
    }, [selectedState])

    const onCreateTask = async (values) => {
        setTaskDialog(false);
        setTimeout(() => {
            fetchData();
        }, 500);
    };

    const onCreate = (values) => {
        let postData = {
            ...values,
        }
        if (values.role == "delegate") {
            postData = {
                ...values,
                state: contextData.userData.state,
                county: contextData.userData.county,
            }
        }
        if (values) {
            postMethod("/user/signup", { ...postData });
        }
        setDialog(false);
        setTimeout(() => {
            fetchData();
        }, 500);
    };

    const onDelete = async (id) => {
        await delMethod("/user", id);
        fetchData();
    }

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const checkEngagements = async (id) => {
        const item = data.find( dataItem => dataItem._id === id);
        if(!item.filledEngagements){
            const response = await getMethod(`/user/engagements/${id}`)
            item.filledEngagements = response.engagements;
        }
        setUserEngagements(item.filledEngagements);
        setShowEngagements(true)
    }

    const handleTableChange = async (paginationChange) => {
        setLoading(true)
        const userData = await getMethod(`/user/${paginationChange.pageSize}/${paginationChange.pageSize * (paginationChange.current - 1)}?state=${selectedState}`);
        setData(userData.list)
        setPagination(paginationChange);
        setLoading(false)
    };

    const [taskUser, setTaskUser] = useState(null);

    // Invoke when user click to request another page.
    const handlePageClick = (page) => {
        const newOffset = (page - 1) * (itemsPerPage)
        setItemOffset(newOffset);
    };

    const columns = [
        {
            title: 'Ad',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Soyad',
            dataIndex: 'surname',
            key: 'surname'
        },
        {
            title: 'Rol',
            dataIndex: 'role',
            key: 'role'
        },
        {
            title: 'Tel',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'İl',
            dataIndex: 'state',
            key: 'state',
        },
        {
            title: 'İlçe',
            dataIndex: 'county',
            key: 'county',
        },
        {
            title: 'Aksiyon',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <Popconfirm title="Silme işlemini onayla" onConfirm={() => onDelete(text._id)}>
                        <a>Sil</a>
                    </Popconfirm>
                    {
                        text.role == "delegate" &&
                        <a onClick={() => { setTaskDialog(true); setTaskUser(text) }}>Görev</a>
                    }
                    {
                       text.engagement.length > 0 && <a onClick={() => { checkEngagements(text._id) }}> Geçmiş </a>
                    }
                </Space>
            ),
        },
    ];

    const EngagementContent = () => {
        const endOffset = itemOffset + itemsPerPage;
        const currentItems = userEngagements.slice(itemOffset, endOffset);
        return <>
            {
                currentItems.map((item, index) => (
                    <Badge.Ribbon key={item._id + index} text={item?.is_completed ? "Tamamlandı" : "Tamamlanmadı"}
                                  color={!item?.is_completed && "red"}>
                        <Card style={{marginBottom: "16px"}}>
                            <Divider>{dateFormat(item?.created_at)} Tarihli Görev</Divider>
                            {item?.data?.taskStatus && <Divider style={{ color: "gray", fontSize: 12}}>{taskStatusToText(item?.data?.taskStatus)}</Divider>}
                            {
                                item?.url &&
                                <>
                                    <h4>Görev Linki</h4>
                                    <Paragraph copyable>{item?.url}</Paragraph>
                                </>
                            }
                            <p>{dateFormat(item?.expiration_date)} tarihinde görev sona eriyor.</p>
                            <h4>Atanılan Kişi</h4>
                            <p style={{margin: 0}}>{item?.birthday_user?.name} {item?.birthday_user?.surname} {item?.birthday_user?.phone}</p>
                            <br/>
                            <h4>Atayan Kişi</h4>
                            <p style={{margin: 0}}>{item?.assigned_by?.name} {item?.assigned_by?.surname} {item?.assigned_by?.phone}</p>
                            {
                                item.data &&
                                <>
                                    <Divider>Anket</Divider>
                                    {
                                        item?.data?.score &&
                                        <>
                                            <h4>Etkinlik Değerlendirmesi</h4>
                                            <p><strong>{item.data.score}</strong></p>
                                        </>
                                    }

                                    {
                                        item?.data?.note &&
                                        <>
                                            <h4>Ziyaret Notları</h4>
                                            <p>{item.data.note}</p>
                                        </>
                                    }

                                    {
                                        item?.data?.photo &&
                                        <>
                                            <h4>Fotoğraflar</h4>
                                            {
                                                item?.data?.photo.map((photo, index) => (
                                                    <p key={index}>
                                                        <img style={{maxWidth: "360px"}} src={photo?.url}/>
                                                    </p>
                                                ))
                                            }
                                        </>
                                    }
                                </>
                            }
                        </Card>
                    </Badge.Ribbon>
                ))}
            <Pagination onChange={handlePageClick} pageSize={itemsPerPage} total={userEngagements.length} />
            </>
    }

    return (
        <>
            <div className="flex space-horizontal" style={{ paddingBottom: "16px" }}>
                <Row gutter={12}>
                    <Col>
                        <Button
                            onClick={() => setDialog(true)}
                            type="primary"
                        >
                            Yeni Ekle
                        </Button>
                    </Col>
                    {
                        ["admin", "admin-center"].includes(contextData.userData.role) &&
                        <>
                            <Col>
                                <Upload {...uploadAdminStateProps}>
                                    <Button
                                        icon={<UploadOutlined />}>
                                        Kullanıcı listesini aktar
                                    </Button>
                                </Upload>
                            </Col>
                        </>
                    }
                </Row>
            </div>


            {["admin", "admin-center"].includes(contextData.userData.role) && <Select
                style={{ minWidth: 200, marginBottom: 10 }}
                onChange={(value) => { setSelectedState(value);}}
                autoComplete="off"
                value={selectedState}
                showSearch
                optionFilterProp="children"
                allowClear
                filterOption={(input, option) =>
                    option.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.children.toLocaleLowerCase('tr').localeCompare(optionB.children.toLocaleLowerCase('tr'))
                }
            >
                {
                    stateList.map(item => (
                        <Option key={item.il_adi} value={item.il_adi}>{item.il_adi}</Option>
                    ))
                }
            </Select>}

            <Table
                loading={loading}
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={data}
                pagination={pagination}
                onChange={handleTableChange}
            />
            <AddUserDialog
                visible={dialog}
                onCreate={onCreate}
                onCancel={() => {
                    setDialog(false);
                }}
            />
            <TaskDialog
                taskUser={taskUser}
                visible={taskDialog}
                onCreate={onCreateTask}
                onCancel={() => {
                    setTaskDialog(false);
                }}
            />

            <Modal
                visible={showEngagements}
                title="Tasks"
                footer={null}
                onCancel={() => setShowEngagements(false)}
            >
                {EngagementContent()}
            </Modal>
        </>
    )
}
